import { generateKeys } from '../utils';
export const communicationTypes = generateKeys({
    sms: {
        value: 'sms',
        label: 'SMS',
    },
    call: {
        value: 'call',
        label: 'Call',
    },
    email: {
        value: 'email',
        label: 'Email',
        link: '/clients/{memberId}/emails/{foreignId}',
    },
    clientNotice: {
        value: 'clientNotice',
        label: 'Client notice',
    },
    marketingPush: {
        value: 'marketingPush',
        label: 'Marketing Push notification',
    },
    marketingNotification: {
        value: 'marketingNotification',
        label: 'Marketing notification',
    },
    marginCall: {
        value: 'marginCall',
        label: 'Margin call',
        link: '/clients/{memberId}/accounts',
    },
    bonusLowEquityWarning: {
        value: 'bonusLowEquityWarning',
        label: 'Bonus low equity warning',
        link: '/clients/{memberId}/accounts',
    },
    depositApproved: {
        value: 'depositApproved',
        label: 'Deposit approved',
        link: '/clients/{memberId}/deposits/{foreignId}',
    },
    accountApproved: {
        value: 'accountApproved',
        label: 'Account approved',
        link: '/clients/{memberId}',
    },
    withdrawalApproved: {
        value: 'withdrawalApproved',
        label: 'Withdrawal approved',
        link: '/clients/{memberId}/withdrawals/{foreignId}',
    },
    kycUploadDocuments: {
        value: 'kycUploadDocuments',
        label: 'KYC Upload Documents',
        link: '/clients/{memberId}/documents',
    },
    kycApproved: {
        value: 'kycApproved',
        label: 'KYC Approved',
        link: '/clients/{memberId}/documents',
    },
    kycRejected: {
        value: 'kycRejected',
        label: 'KYC Rejected',
        link: '/clients/{memberId}/documents',
    },
    poiRejected: {
        value: 'poiRejected',
        label: 'POI Rejected',
        link: '/clients/{memberId}/documents/{foreignId}',
    },
    porRejected: {
        value: 'porRejected',
        label: 'POR Rejected',
        link: '/clients/{memberId}/documents/{foreignId}',
    },
    porMissing: {
        value: 'porMissing',
        label: 'POR Missing',
        link: '/clients/{memberId}/documents',
    },
    poiMissing: {
        value: 'poiMissing',
        label: 'POI Missing',
        link: '/clients/{memberId}/documents',
    },
    depositOnHold: {
        value: 'depositOnHold',
        label: 'Deposit On Hold',
        link: '/clients/{memberId}/deposits/{foreignId}',
    },
    depositDeclined: {
        value: 'depositDeclined',
        label: 'Deposit Declined',
        link: '/clients/{memberId}/deposits/{foreignId}',
    },
    withdrawalRejected: {
        value: 'withdrawalRejected',
        label: 'Withdrawal Rejected',
        link: '/clients/{memberId}/withdrawals/{foreignId}',
    },
    appropTestPending: {
        value: 'appropTestPending',
        label: 'Appropriateness Test Pending',
        link: '/clients/{memberId}',
    },
    accountSuspended: {
        value: 'accountSuspended',
        label: 'Account Suspended',
        link: '/clients/{memberId}',
    },
    sendLocalDepositorEmail: {
        value: 'sendLocalDepositorEmail',
        label: 'Local Depositor Email',
        link: '/clients/{memberId}/emails/{foreignId}',
    },
    sendSubscribedClientEmail: {
        value: 'sendSubscribedClientEmail',
        label: 'Client Subscription Email',
        link: '/clients/{memberId}/emails/{foreignId}',
    },
    sendLocalDepositorStatusEmail: {
        value: 'sendLocalDepositorStatusEmail',
        label: 'Local Depositor Status Email',
        link: '/clients/{memberId}/emails/{foreignId}',
    },
});
export const communicationChannels = generateKeys({
    email: {
        value: 'email',
        label: 'Email',
    },
    call: {
        value: 'call',
        label: 'Call',
    },
    sms: {
        value: 'sms',
        label: 'SMS',
    },
    pushNotification: {
        value: 'pushNotification',
        label: 'Push notification',
    },
    clientNotice: {
        value: 'clientNotice',
        label: 'Client notice',
    },
    marketingNotification: {
        value: 'marketingNotification',
        label: 'Marketing notification',
    },
});
